/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Paper, IconButton, TablePagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { formatUtcForDisplay } from '../utils/dateTime';

function EncomendaList({
  refresh,
  onEdit,
  onEncomendaDeleted,
  filterCodigoRastreio,
  selectedRemetenteIds = [],
  selectedDestinatarioIds = [],
  dataRecebimentoStart,
  dataRecebimentoEnd,
  todasEncomendas,
}) {
  const { user, token } = useAuth();
  const [encomendas, setEncomendas] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [sendingWhatsappIds, setSendingWhatsappIds] = useState([]);

  const fetchEncomendas = () => {
    const params = new URLSearchParams({ page: String(page), limit: String(rowsPerPage) });
    if (todasEncomendas) params.append('todas', 'true');
    if (filterCodigoRastreio) params.append('codigoRastreio', filterCodigoRastreio);
    if (selectedRemetenteIds.length > 0) params.append('remetenteIds', selectedRemetenteIds.join(','));
    if (selectedDestinatarioIds.length > 0) params.append('destinatarioIds', selectedDestinatarioIds.join(','));
    if (dataRecebimentoStart) params.append('dataRecebimentoStart', dataRecebimentoStart);
    if (dataRecebimentoEnd) params.append('dataRecebimentoEnd', dataRecebimentoEnd);

    api.get(`/encomendas?${params.toString()}`)
      .then((response) => {
        setEncomendas(response.data.data);
        setTotalCount(response.data.totalCount);
      })
      .catch((error) => console.error('Erro ao buscar encomendas:', error));
  };

  useEffect(() => {
    fetchEncomendas();
  }, [
    refresh,
    page,
    rowsPerPage,
    filterCodigoRastreio,
    selectedRemetenteIds,
    selectedDestinatarioIds,
    dataRecebimentoStart,
    dataRecebimentoEnd,
    todasEncomendas,
  ]);

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar esta encomenda?')) return;
    try {
      await api.delete(`/encomendas/${id}`);
      onEncomendaDeleted();
    } catch (error) {
      console.error('Erro ao deletar encomenda:', error);
    }
  };

  const handleEnviarWhatsapp = async (encomendaId) => {
    if (sendingWhatsappIds.includes(encomendaId)) return;
    const authToken = token || localStorage.getItem('token');
    if (!authToken) {
      alert('Sessao expirada. Faca login novamente.');
      return;
    }
    const requestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    try {
      setSendingWhatsappIds((prev) => [...prev, encomendaId]);
      let response;
      try {
        response = await api.post(`/encomendas/notify-whatsapp/${encomendaId}`, {}, requestConfig);
      } catch (firstError) {
        // Compatibilidade com backend em versao antiga.
        if (firstError.response?.status !== 404) {
          throw firstError;
        }
        response = await api.post(`/encomendas/${encomendaId}/notify-whatsapp`, {}, requestConfig);
      }
      alert(response.data?.message || 'Mensagem enviada com sucesso.');
      fetchEncomendas(); // Refresh the list to get the updated data_hora_ultimo_whatsapp
    } catch (error) {
      const msg = error.response?.data?.message || 'Erro ao enviar mensagem de WhatsApp.';
      const detail = error.response?.data?.detail;
      alert(detail ? `${msg}
Detalhe: ${detail}` : msg);
    } finally {
      setSendingWhatsappIds((prev) => prev.filter((id) => id !== encomendaId));
    }
  };

  return (
    <Paper>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="encomendas table">
          <TableHead>
            <TableRow>
              {(user && user.tipo_usuario === 'admin') && <TableCell>Empresa</TableCell>}
              <TableCell>Recebimento</TableCell>
              <TableCell>Func. Recebeu</TableCell>
              <TableCell>Casa</TableCell>
              <TableCell>Destinatario</TableCell>
              <TableCell>Rastreio</TableCell>
              <TableCell>Retirada</TableCell>
              <TableCell>Acoes</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {encomendas.map((encomenda) => (
              <TableRow key={encomenda.id} hover>
                {(user && user.tipo_usuario === 'admin') && <TableCell>{encomenda.empresa_nome || encomenda.empresa_id}</TableCell>}
                <TableCell>{formatUtcForDisplay(encomenda.data_hora_recebimento, user)}</TableCell>
                <TableCell>{encomenda.funcionario_recebeu_email || encomenda.funcionario_recebeu_id}</TableCell>
                <TableCell>{encomenda.destinatario_numero_casa || 'N/A'}</TableCell>
                <TableCell>{encomenda.destinatario_nome || encomenda.destinatario_id}</TableCell>
                <TableCell>{encomenda.codigo_rastreio || 'N/A'}</TableCell>
                <TableCell>{formatUtcForDisplay(encomenda.data_hora_retirada, user)}</TableCell>
                <TableCell>
                  <IconButton
                    aria-label="enviar whatsapp"
                    onClick={() => handleEnviarWhatsapp(encomenda.id)}
                    disabled={
                      sendingWhatsappIds.includes(encomenda.id) ||
                      !!encomenda.data_hora_ultimo_whatsapp
                    }
                    title={encomenda.data_hora_ultimo_whatsapp ? `Mensagem enviada em ${formatUtcForDisplay(encomenda.data_hora_ultimo_whatsapp, user)}` : "Enviar mensagem de WhatsApp para destinatario"}
                  >
                    <WhatsAppIcon />
                  </IconButton>
                  <IconButton aria-label="edit" onClick={() => onEdit(encomenda)}><EditIcon /></IconButton>
                  <IconButton aria-label="delete" onClick={() => handleDelete(encomenda.id)}><DeleteIcon /></IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        onRowsPerPageChange={(event) => { setRowsPerPage(parseInt(event.target.value, 10)); setPage(0); }}
        labelRowsPerPage="Linhas por pagina:"
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </Paper>
  );
}

export default EncomendaList;
